import axiosInstance from "../../../../axios/axios";

/**
 * Fetch My Embryo / Oocyte Transfer Permits
 * Endpoint: /api/EmbryoOocyteTransferPermitServiceRequest/GetMyEmbryoOocyteTransferPermits
 *
 * @param {Object} params
 * @param {string} [params.status=""] - Filter by status (e.g. 'Active', 'Expired', 'Refused', or empty for all)
 * @param {string} [params.searchTerm=""] - Search term (mare name, reg no, permit ref)
 * @param {number} [params.pageNumber=1] - 1-based page number
 * @param {number} [params.pageSize=10] - Number of items per page
 * @returns {Promise<Object>} API response data
 */
export const fetchMyEmbryoTransferPermitsApi = async ({
    status = "",
    searchTerm = "",
    pageNumber = 1,
    pageSize = 10,
} = {}) => {
    const params = {
        pageNumber,
        pageNumbers: pageNumber,
        pageSize,
    };

    if (status && status !== "all") {
        params.status = status;
    }

    if (searchTerm && searchTerm.trim()) {
        params.searchTerm = searchTerm.trim();
    }

    const response = await axiosInstance.get(
        "/EmbryoOocyteTransferPermitServiceRequest/GetMyEmbryoOocyteTransferPermits",
        { params }
    );

    return response?.data;
};
